module.exports = __webpack_public_path__ + "static/media/actionCurve.31519d26.png";